import { AnyAction, combineReducers } from 'redux';
import { ReceiptAlert } from '@synergy/models';

import { DEMAND_DETAIL_OVERVIEW_RECEIVE } from './overview/demand-detail-overview-actions';
import {
    DEMAND_DETAIL_RESET,
    DEMAND_DETAIL_TOTAL_QUANTITY_POSITIONS_RECEIVED,
    DEMAND_DETAIL_TRANSITION_DATA_RECEIVED,
    DEMAND_DETAIL_UNLOCK_TOGGLE,
} from './demand-detail-actions';
import { Demand } from '../../../models/demand';
import { DemandCompletionStatus } from '../../../models/demand-completion-status';
import {
    DemandDetailFeedbackReducerState,
    demandDetailFeedbackReducer,
} from './feedback/demand-detail-feedback-reducer';
import {
    DemandDetailOverviewReducerState,
    demandDetailOverviewReducer,
} from './overview/demand-detail-overview-reducer';
import {
    DemandDetailParticipantsReducerState,
    demandDetailParticipantsReducer,
} from './participants/demand-detail-participants-reducer';
import {
    DemandDetailPositionsReducerState,
    demandDetailPositionsReducer,
} from './positions/demand-detail-positions-reducer';
import { DemandDetailTopicsReducerState, demandDetailTopicsReducer } from './topics/demand-detail-topics-reducer';
import { DemandItem } from '../../../models/demand-item';
import { UPDATE_DEMAND_ALERT } from '../../../demand-actions';

interface DemandDetailCommonReducerState {
    unlocked: boolean;
    receiptAlert?: ReceiptAlert;
    demandTransitionData?: Demand;
    completionStatus: DemandCompletionStatus;
    totalQuantityDemandPositions: DemandItem[];
}

const demandDetailCommonInitialState: DemandDetailCommonReducerState = {
    unlocked: false,
    completionStatus: {
        created: false,
        positions: false,
        topics: false,
        participants: false,
        notifications: false,
    },
    totalQuantityDemandPositions: [],
};

const demandDetailCommonReducer = (
    state: DemandDetailCommonReducerState = demandDetailCommonInitialState,
    action: AnyAction
) => {
    switch (action.type) {
        case DEMAND_DETAIL_OVERVIEW_RECEIVE: {
            const demand = action['demand'];
            return {
                ...state,
                receiptAlert: demand.receiptAlert,
                completionStatus: demand.completionStatus,
            };
        }

        case UPDATE_DEMAND_ALERT: {
            return {
                ...state,
                receiptAlert: action['alert'],
            };
        }

        case DEMAND_DETAIL_UNLOCK_TOGGLE: {
            return {
                ...state,
                unlocked: !state.unlocked,
            };
        }

        case DEMAND_DETAIL_RESET: {
            return demandDetailCommonInitialState;
        }

        case DEMAND_DETAIL_TRANSITION_DATA_RECEIVED: {
            return {
                ...state,
                demandTransitionData: action['transitionData'],
            };
        }

        case DEMAND_DETAIL_TOTAL_QUANTITY_POSITIONS_RECEIVED: {
            return {
                ...state,
                totalQuantityDemandPositions: action['totalQuantity'],
            };
        }

        default:
            return state;
    }
};

export interface DemandDetailReducerState {
    overview: DemandDetailOverviewReducerState;
    positions: DemandDetailPositionsReducerState;
    topics: DemandDetailTopicsReducerState;
    participants: DemandDetailParticipantsReducerState;
    feedback: DemandDetailFeedbackReducerState;
    common: DemandDetailCommonReducerState;
}

export const demandDetailReducer = combineReducers<DemandDetailReducerState>({
    overview: demandDetailOverviewReducer,
    positions: demandDetailPositionsReducer,
    topics: demandDetailTopicsReducer,
    participants: demandDetailParticipantsReducer,
    feedback: demandDetailFeedbackReducer,

    common: demandDetailCommonReducer,
});
